/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


$(document).ready(function(){

  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }

  // ----------------------------------------------------------------------------------------------------------------------
  $('.ll-custom__list').slick({
    slidesToShow: 4,
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      }
    ]
  });
  $('.category-list_main').slick({
    slidesToShow: 6,
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          arrows: false,
          slidesToShow: 2
        }
      }
    ]
  });
  $('.image-vertical-slider').slick({
    slidesToShow: 1,
    vertical: true,
    arrows: false,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 2000
  });
  $('.sticky_strip_slider').slick({
    slidesToShow: 1,
    arrows: false,
    dots: false,
    infinite: true,
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 3000
  });
  $('.category-list_images-main').slick({
    slidesToShow: 2,
    arrows: false,
    dots: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          arrows: false,
          slidesToShow: 1
        }
      }
    ]
  });
  // $('.product-list_main').slick({
  //   slidesToShow: 3,
  //   arrows: true,
  //   dots: false,
  //   infinite: false,
  //   prevArrow: $('.product-list-arrow_prev'),
  //   nextArrow: $('.product-list-arrow_next'),
  //   responsive: [
  //     {
  //       breakpoint: 999,
  //       settings: "unslick"
  //     }
  //   ]
  // });
  
  $('.product-list_section').each(function (i, section) {

    var swiper = new Swiper($(section).find(".product-list_main")[0], {
      slidesPerView: 3,
      navigation: {
        nextEl: $(section).find(".product-list-arrow_next")[0],
        prevEl: $(section).find(".product-list-arrow_prev")[0],
      },
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        767: {
          enabled: true,   // ✅ enable slider 999px and above
          slidesPerView: 2
        },
        999: {
          enabled: true,   // ✅ enable slider 999px and above
          slidesPerView: 3
        }
      }
    });

  });

  $('.plsc_slider').each(function (i, section) {

  const isGridMobile =
    $(section).hasClass('grid-in-mobile');

    // MOBILE + GRID CLASS
    if (
      isGridMobile &&
      window.innerWidth < 767
    ) {
      // return;
    }else{
      var swiper = new Swiper(
        $(section).find(".plsc_slider-row")[0],
        {

          slidesPerView: 2,

          navigation: {
            nextEl:
              $(section).find(".plsc_next")[0],

            prevEl:
              $(section).find(".plsc_prev")[0],
          },

          breakpoints: {

            0: {
              slidesPerView: 1
            },

            767: {
              slidesPerView: 2
            },

            999: {
              slidesPerView: 2
            }

          }

        }
      );
    }

  });

  // $('.plsc_slider-row').slick({
  //   slidesToShow: 2,
  //   arrows: true,
  //   dots: false,
  //   infinite: false,
  //   prevArrow: `<button class="slick-prev slick-arrow plsc_arrow" aria-disabled="false" style=""><svg width="40" height="40" class="icon icon--carousel-left   " viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="26.5" cy="26.5" r="26.5" transform="matrix(-1 0 0 1 53 0)" fill="#B28C42"></circle><path d="M25.6755 35.9621L16.2779 26.6503C18.6522 24.3388 23.3699 19.72 25.7443 17.4084L26.9304 18.5646C24.7945 20.6435 21.9692 23.4137 19.4766 25.8433L34.8345 25.9003L34.8284 27.5381L19.4705 27.4812L26.8701 34.8022L25.6755 35.9621Z" fill="currentColor"></path></svg></button>`,
  //   nextArrow: `<button class="slick-next slick-arrow plsc_arrow" aria-disabled="false" style=""><svg width="40" height="40" class="icon icon--carousel-right   " viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="26.5" cy="26.5" r="26.5" fill="#B28C42"></circle><path d="M27.3245 35.9621L36.7221 26.6503C34.3478 24.3388 29.6301 19.72 27.2557 17.4084L26.0696 18.5646C28.2055 20.6435 31.0308 23.4137 33.5234 25.8433L18.1655 25.9003L18.1716 27.5381L33.5295 27.4812L26.1299 34.8022L27.3245 35.9621Z" fill="currentColor"></path></svg></button>`,
  //   responsive: [
  //     {
  //       breakpoint: 999,
  //       settings: "unslick"
  //     }
  //   ]
  // });

  $('.ingredients_row').slick({
    slidesToShow: 3,
    arrows: true,
    dots: false,
    infinite: true,
    centerMode: true,
    centerPadding: '0',
    prevArrow: `<button class="slick-prev slick-arrow ingredients_arrow" aria-disabled="false" style=""><svg width="40" height="40" class="icon icon--carousel-left   " viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="26.5" cy="26.5" r="26.5" transform="matrix(-1 0 0 1 53 0)" fill="#B28C42"></circle><path d="M25.6755 35.9621L16.2779 26.6503C18.6522 24.3388 23.3699 19.72 25.7443 17.4084L26.9304 18.5646C24.7945 20.6435 21.9692 23.4137 19.4766 25.8433L34.8345 25.9003L34.8284 27.5381L19.4705 27.4812L26.8701 34.8022L25.6755 35.9621Z" fill="currentColor"></path></svg></button>`,
    nextArrow: `<button class="slick-next slick-arrow ingredients_arrow" aria-disabled="false" style=""><svg width="40" height="40" class="icon icon--carousel-right   " viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="26.5" cy="26.5" r="26.5" fill="#B28C42"></circle><path d="M27.3245 35.9621L36.7221 26.6503C34.3478 24.3388 29.6301 19.72 27.2557 17.4084L26.0696 18.5646C28.2055 20.6435 31.0308 23.4137 33.5234 25.8433L18.1655 25.9003L18.1716 27.5381L33.5295 27.4812L26.1299 34.8022L27.3245 35.9621Z" fill="currentColor"></path></svg></button>`,
    responsive: [
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

  $(function() {
    $('.easy-to-use_row').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
        mobileFirst: true,
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 741,
            settings: 'unslick'
          }
        ]
    });

    $(window).on('resize', function() {
        $('.easy-to-use_row').slick('resize');
    });

    $('body').on('click','.floating-call-text-close', function (e){
      e.preventDefault();
      $('.floating-call-text').hide();
    })

});
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

 document.addEventListener('variant:changed', function(event) {
   let variant = event.detail.variant; // Gives you access to the whole variant details
   let form = event.target;
   if($('[data-ai-product-price-list]').length > 0){
    if (!variant) {
      $('[data-ai-product-price-list]').hide();
    } else {
      var aip = `<span class="price ai-form__price">
        ${formatMoney(variant["price"], currencyFormat)}
      </span>`;
      $('[data-ai-product-price-list]').html(aip).show();
    }
   }

   if($('[data-prepaid-off]').length > 0){
     var prepaid_amnt = variant.price - 5000;
     $('[data-prepaid-off]').html(`${formatMoney(prepaid_amnt, currencyFormat)}`);
   }

   if(document.getElementById('productvariantJson')){
    var varproductData = JSON.parse(document.getElementById('productvariantJson').textContent);
    var variantInfo = varproductData.variants[variant.id];
    console.log(variantInfo);
    if(variantInfo.enabledoublepopup){
      $('.product__info').find('[data-dummy-atc]').show();
      $('.product__info').find('[data-product-add-to-cart-button]').hide()
      var variantprice = variant.price;
      var variantcompprice = variant.compare_at_price;
      var doubleprice = variantprice * 2;
      var savingamnt = (10 * doubleprice) / 100;
      var totalamnt = doubleprice - savingamnt;
      var doublecompprice = variantcompprice * 2;
      var comphtml = ``;
      var dblcomphtml = ``;
      if(variantcompprice > variantprice){
        var save = variantcompprice - variantprice;
        var dblsave = doublecompprice - totalamnt;
        comphtml = `<p class="total_amount summary_line">
          Total: <strong>${formatMoney(variantprice, currencyFormat)} <del>${formatMoney(variantcompprice, currencyFormat)}</del></strong>
        </p>
        <div class="savings">
          ✅ You save ${formatMoney(save, currencyFormat)}
        </div>`;
        dblcomphtml = `<p class="total_amount summary_line">Total: <strong>${formatMoney(totalamnt, currencyFormat)} <del>${formatMoney(doublecompprice, currencyFormat)}</del></strong></p>
        <div class="savings">
          ✅ You save ${formatMoney(dblsave, currencyFormat)}
        </div>`;
      }else{
        comphtml = `<p class="total_amount summary_line">
          Total: <strong>${formatMoney(variantprice, currencyFormat)}</strong>
        </p>`;
        dblcomphtml = `<p class="total_amount summary_line">Total: <strong>${formatMoney(doubleprice, currencyFormat)}</strong></p>`;
      }
      
        
      var pophtml = `
    <div class="offer-card">
      <h3 class="block_heading ">Single Item</h3>
      <p class="current">Current selection</p>
      <img src="${variantInfo.singleimage}" width="140" height="140" 
        loading="lazy" 
        alt="Product">
      <div class="details">
        <p class="quantity_line summary_line">Quantity: <strong>1x</strong></p>
        ${comphtml}
      </div>
    </div>

    <!-- Double Pack -->
    <div class="offer-card recommended">
      <div class="badge">Recommended</div>
      <h3 class="block_heading">Double Pack</h3>
      <p class="save">Save Extra 10%</p>
      <div class="images">
        <img src="${variantInfo.doubleimage}" width="140" height="140" 
        loading="lazy" 
        alt="Product">
      </div>
      <div class="details">
        <p class="quantity_line summary_line">Quantity: <strong>2x</strong></p>
        
        ${dblcomphtml}
      </div>        
    </div>`;
    $('.offer-model .offer-content').html(pophtml);
    }
  }
 });

  if (window.matchMedia('(max-width: 740px)').matches){
    // do functionality on screens smaller than 768px
    $('.footer__item--link-title').click(function(){
      $(this).toggleClass('active');
      $(this).parents('.footer__item').find('.footer__item-content').slideToggle();
    });
  }
  $('body').on('click', '.product-list_grid-view', function(e) {
    e.preventDefault();
    $('.product-list_grid-view').removeClass('active');
    $(this).addClass('active');
    $("product-list").attr("list-type", $(this).attr('href'));
    console.log($(this).attr('href'));
  });

  $("body").on('click','.ai-header', function () {
    $(this).toggleClass("active");
    $(".ai-content-wrapper").slideToggle();
  });

  $("body").on('click','.offer-model .close-btn', function () {
    var _this = this;
    $('.offer-model, .offermodel_overlay').removeClass('active');
    $(this).closest('.product__info').find('[name="quantity"]').val(1);
    $(this).closest('.product__info').find('[data-dummy-atc]').hide();
    $(this).closest('.product__info').find('[data-product-add-to-cart-button]').show().trigger('click');
    setTimeout(function(){
      $(_this).closest('.product__info').find('[data-dummy-atc]').show();
      $(_this).closest('.product__info').find('[data-product-add-to-cart-button]').hide();
    },2000);
  });

  $("body").on('click','[data-dummy-atc]', function () {
    $('.offer-model, .offermodel_overlay').addClass('active');
  });
  $("body").on('click','[data-continue]', function () {
    var _this = this;
    $('.offer-model, .offermodel_overlay').removeClass('active');
    $(this).closest('.product__info').find('[name="quantity"]').val(1);
    $(this).closest('.product__info').find('[data-dummy-atc]').hide();
    $(this).closest('.product__info').find('[data-product-add-to-cart-button]').show().trigger('click');
    setTimeout(function(){
      $(_this).closest('.product__info').find('[data-dummy-atc]').show();
      $(_this).closest('.product__info').find('[data-product-add-to-cart-button]').hide();
    },2000);
  });
  $("body").on('click','[data-adddoubleqty]', function () {
    var _this = this;
    $('.offer-model, .offermodel_overlay').removeClass('active');
    $(this).closest('.product__info').find('[name="quantity"]').val(2);
    $(this).closest('.product__info').find('[data-dummy-atc]').hide();
    $(this).closest('.product__info').find('[data-product-add-to-cart-button]').show().trigger('click');
    setTimeout(function(){
      $(_this).closest('.product__info').find('[data-dummy-atc]').show();
      $(_this).closest('.product__info').find('[data-product-add-to-cart-button]').hide();
    },2000);
  });

  //STORE LOCATOR
  $('body').on('click','.search_submit_filter', function(){    
    var state = '', city = '',locality = '';
    if($(this).closest('.sl--filter-row').find('[name="state"]').length > 0){
      state = $(this).closest('.sl--filter-row').find('[name="state"]').val();  
    }
    if($(this).closest('.sl--filter-row').find('[name="city"]').length > 0){
      city = $(this).closest('.sl--filter-row').find('[name="city"]').val();  
    }
    if($(this).closest('.sl--filter-row').find('[name="locality"]').length > 0){
      locality = $(this).closest('.sl--filter-row').find('[name="locality"]').val();  
    }
    var mergeval = state + city + locality;
    var spaceremoved = mergeval.replaceAll(' ','');        
    var cnt = 0;
    if(spaceremoved != ''){
      $(".stor-locator-grid-item").filter(function() {
        $(this).toggle($(this).attr('data-serachval').indexOf(spaceremoved) > -1);
        if($(this).attr('data-serachval').indexOf(spaceremoved) > -1){
          cnt++;
        }
      });
      if(cnt == 0){
        $('.stor-locator-result').hide();
        $('.stor-locator-noresult').removeAttr('hidden');
      }else{
        $('.stor-locator-result').show();
        $('.stor-locator-noresult').attr('hidden', true);
      } 
    }else{
      $(".stor-locator-grid-item").show();
      $('.stor-locator-result').show();
      $('.stor-locator-noresult').attr('hidden', true);
    }   
  });

  if($(".stor-locator-grid-item").length > 0){
    var hash = window.location.hash.replace("#", "");
    if (hash) {
      var country = hash.split(',')[0]; // Gujarat
      var city = hash.split(',')[1];     // Surat
      console.log(country, city)
      if($('#OutletState').length > 0 && $('#OutletCity').length > 0){
        $('#OutletState').val(country).trigger('change');
        $('#OutletCity').val(city).trigger('change');
        $('.search_submit_filter').trigger('click');
        history.replaceState(null, null, window.location.pathname);
      }
    }
    $(window).on("hashchange", function () {
      location.reload();
    });

  }

  //BUNDLE PAGE
  
  function activecheck(addedcnt,bundle_compare_price){
    if(addedcnt == parseInt($('.bundle-product-list').attr('data-bundleitemcnt'))){
      $('.bundle-product-item__cta:not(.added)').attr('disabled','disabled');
      $('.bundle-add_to_cart_button').html(`<span class="loader-button__text"><span class="product-item__cta-text">Add to cart<svg width="18" height="18" class="icon icon--quick-buy-shopping-cart   " viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.592726 0.774894C1.04345 0.713177 2.05356 0.720973 2.51557 0.7645C2.80061 0.791136 3.00192 0.917169 3.12425 1.20302C3.37782 1.79745 3.48293 2.71476 3.76025 3.26827C3.83863 3.42484 3.96215 3.52943 4.12605 3.55022L14.4226 3.55737C14.8288 3.58985 15.1049 4.0537 14.9618 4.47468C14.346 6.23005 13.9475 8.17576 13.3079 9.90904C13.1844 10.2436 13.0585 10.4424 12.6999 10.4781L5.84224 10.4794C5.72288 10.497 5.59401 10.5769 5.53225 10.6925C5.46218 10.8238 5.32679 11.4507 5.35589 11.5904C5.38795 11.7437 5.58332 11.8658 5.7205 11.8736L13.438 11.8762C14.1286 12.0256 14.0942 13.1697 13.3822 13.2392H5.54176C4.83865 13.1573 4.25729 12.5648 4.11595 11.8106C3.96096 10.9823 4.5061 10.2631 4.29589 9.4374L2.17352 2.46984C2.12304 2.32497 1.99596 2.19764 1.85403 2.1697C1.38668 2.0768 0.547594 2.33991 0.196637 1.96896C-0.20539 1.54214 0.0499597 0.848955 0.592726 0.774894Z" fill="currentColor"></path>
        <path d="M4.17296 16.3133C2.9271 14.9504 4.95564 12.9748 6.0483 14.4404C7.07148 15.8131 5.29056 17.536 4.17296 16.3133Z" fill="currentColor"></path>
        <path d="M11.7741 16.3133C10.5282 14.9504 12.5567 12.9748 13.6494 14.4404C14.6726 15.8131 12.8917 17.536 11.7741 16.3133Z" fill="currentColor"></path>
      </svg></span></span><span class="loader-button__loader"><div class="spinner"><svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50"><circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle></svg></div></span>`).addClass('readytoadd button--gradient').removeClass('button--outline');
      $('.bundle-preview_cart-prices').show();
    }else{
      $('.bundle-product-item__cta:not(.added)').removeAttr('disabled');
      $('.bundle-add_to_cart_button').html('Add To Box').addClass('button--outline').removeClass('readytoadd button--gradient');
      $('.bundle-preview_cart-prices').hide();
    }
    $('.bundle-preview_cart-prices .price--compare').html(formatMoney(bundle_compare_price, currencyFormat));
    
    if(addedcnt > 0){
      $('.bundle-preview_cart').show();
    }else{
      $('.bundle-preview_cart').hide();
    }
  }
  var addedcnt = 0;
  var bundle_compare_price = 0;
  $('body').on('click', '.bundle-product-item__cta', function(e){
    e.preventDefault();
    addedcnt += 1;
    bundle_compare_price += parseInt($(this).attr('data-compare_price'));

    activecheck(addedcnt,bundle_compare_price);     
    $(this).attr("disabled","disabled").addClass('added button--outline').removeClass('button--gradient').html(`Added`);
    $(this).before(`<span class="bundle-product-item__cta-remove text--xsmall">x</span>`);
    var featuredimage = $(this).closest('.product-item').attr('data-featuredimage');
    var itembox = `<div class="bundle-preview_cart-item-wrapper"><img src="${featuredimage}" loading="lazy" width="50" height="50" alt=""><div class="bundle-preview_car-item-remove text--xsmall">x</div></div>`; 
    $('.bundle-preview_cart-item.hasblank').first().html(itembox);
    $('.bundle-preview_cart-item.hasblank').first().attr('data-vid',$(this).closest('.product-item').attr('data-variant-id')).attr('data-pid',$(this).closest('.product-item').attr('data-product-id')).attr('data-price',$(this).closest('.product-item').attr('data-product-price')).removeClass('hasblank');    
  });

  $('body').on('click', '.bundle-product-item__cta-remove', function(e){
    e.preventDefault();    
    addedcnt = addedcnt - 1;
    bundle_compare_price = bundle_compare_price - parseInt($(this).next().attr('data-compare_price'));
    activecheck(addedcnt,bundle_compare_price); 
    $(this).next().removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient').html(`Add to box`);
    $(`.bundle-preview_cart-item[data-pid="${$(this).closest('.product-item').attr('data-product-id')}"]`).addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
    $(this).remove();
  });

  $('body').on('click','.bundle-preview_car-item-remove', function(){
    addedcnt = addedcnt - 1;
    bundle_compare_price = bundle_compare_price - parseInt($(this).closest('.bundle-preview_cart-item').attr('data-price'));
    activecheck(addedcnt,bundle_compare_price); 
    $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.bundle-product-item__cta-remove').remove();
    $(`.product-item[data-product-id="${$(this).closest('.bundle-preview_cart-item').attr('data-pid')}"]`).find('.bundle-product-item__cta').removeAttr("disabled").removeClass('added button--outline').addClass('button--gradient').html(`Add to box`);
    $(this).closest('.bundle-preview_cart-item').addClass('hasblank').removeAttr('data-pid').removeAttr('data-vid').removeAttr('data-price').html('<div class="bundle-preview_cart-item-wrapper">Add</div>');
  });

  $('body').on('click','.bundle-add_to_cart_button.readytoadd ', function(){
    $(this).attr("aria-busy",true);
    var items = [];
    $(this).closest('.bundle-preview_cart-main').find('.bundle-preview_cart-item:not(.hasblank)').each(function(i,v){
      var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });   
    });    
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {      
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
      $(this).removeAttr("aria-busy");
    }.bind(this));  
    
  });

  //PRODUCT FBT SECTION
  $('body').on('change','.fbt-item-checkbox', function(){
    var fbt_total_price = 0;
    var fbt_total_copmpare_price = 0;
    var fbt_total_discount_price = 0;
    var product_handle = $("body").attr("product-handle");
    var selected_variant_id = parseInt($('.fbt-item:first').find('.fbt-item-checkbox').attr('data-vid'));

    $(".fbt-item:has( .fbt-item-checkbox:checked)").each(function() {        
      var single_product_discount_price = parseInt($(this).find('.fbt-item-checkbox:checked').attr('variant-compare-price')) - parseInt($(this).find('.fbt-item-checkbox:checked').attr('variant-price'))
      fbt_total_price = fbt_total_price + parseInt($(this).find('.fbt-item-checkbox:checked').attr('variant-price'))
      fbt_total_copmpare_price = fbt_total_copmpare_price + parseInt($(this).find('.fbt-item-checkbox:checked').attr('variant-compare-price'))
      fbt_total_discount_price = fbt_total_discount_price + single_product_discount_price
    });
    console.log('price',fbt_total_price,fbt_total_copmpare_price,formatMoney(fbt_total_price, currencyFormat),formatMoney(fbt_total_copmpare_price, currencyFormat))

    $(this).closest('.fbt-main').find('.fbt-product-bundle_final-price').html(formatMoney(fbt_total_price, currencyFormat)); 
    $(this).closest('.fbt-main').find('.fbt-product-bundle-compare_price').html(formatMoney(fbt_total_copmpare_price, currencyFormat)); 
    $(this).closest('.fbt-main').find('.fbt-product-bundle_discount-price').html(formatMoney(fbt_total_discount_price, currencyFormat)); 
    if($('.fbt-item-checkbox:checked').length == 0){
      console.log($('.fbt-item-checkbox:checked').length);
      $(".fbt-product-bundle__cta").attr("disabled",true)
    }else{
      $(".fbt-product-bundle__cta").removeAttr("disabled");
    }
  });
  $('body').on('click','.fbt-product-bundle__cta', function(){      
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    var itemdata = [];
    var totalprice = 0;
    var items = [];
    $(this).closest('.fbt-main').find('.fbt-item-checkbox:checked').each(function(i,v){
       var val = $(this).attr('data-vid');         
       items.push({
        quantity: 1,
        id: val
      });
      itemdata.push({
        Title: $(this).attr('data-itemtitle'),
        Price: $(this).attr('variant-price')
      });
      totalprice += parseInt($(this).attr('variant-price'));
    }); 
    mixpanel.track('FBT Clicks', {
      'Items': itemdata,
      'FBT Total': formatMoney(totalprice, currencyFormat)
    });
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      _this.removeAttr("disabled");
      _this.removeAttr("aria-busy");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
    }.bind(this));  
  });

  $('body').on('click','.combo-products__cta', function(){      
    var _this = $(this);
    _this.attr("disabled", "disabled");
    _this.attr("aria-busy", "true");
    
    var items = [];
    $(this).closest('.combo-products').find('.combo-product_item').each(function(i,v){
       var val = $(this).attr('variant-id');         
       items.push({
        quantity: 1,
        id: val
      });
    }); 
    
    var data = {items};
    console.log('data',data)
    // var data = theme.utils.serialize(this.form);
   
    fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(function(data) {
      _this.removeAttr("disabled");
      _this.removeAttr("aria-busy");
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      document.getElementById('mini-cart').open = true;
    }.bind(this));  
  });

  $('.custom-faq-list_item-title').click(function(){
   $(this).toggleClass('active');
   $(this).next('.custom-faq-list_item-content').slideToggle();
});

  $("body").on("click", ".product-offer_item-code:not(.no-code)", function () {
    var copy_text = $(this);
    var text = $(this).text();
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.attr("copied","copied")
      
    setTimeout(function () {
      copy_text.removeAttr("copied");
    }, 1000);
  });
  $('body').on('click', '.cart-total', function() {
    $(this).toggleClass('active');
    $(this).prev('.cart-payment-summary').toggle();
  });

  function startCountdown() {
    const countdownElement = document.getElementById("countdown-timer");

    function updateTimer() {
      const now = new Date();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      // Calculate the time remaining until the next 5-minute mark
      const nextCycleMinutes = Math.ceil(minutes / 5) * 5;
      const nextCycleTime = new Date(now);
      nextCycleTime.setMinutes(nextCycleMinutes, 0, 0);

      let timeRemaining = Math.floor((nextCycleTime - now) / 1000);

      // If time remaining is negative, reset it for the next cycle
      if (timeRemaining < 0) {
        timeRemaining += 5 * 60;
      }

      // Convert to minutes and seconds
      const displayMinutes = Math.floor(timeRemaining / 60);
      const displaySeconds = timeRemaining % 60;

      // Display the countdown timer
      countdownElement.textContent = 
        `${displayMinutes}m : ${displaySeconds < 10 ? "0" : ""}${displaySeconds}s`;

      // Refresh the timer every second
      setTimeout(updateTimer, 1000);
    }

    updateTimer();
  }

  startCountdown();

  // APPLY COUPON SCRIPT
  
  //set cookie
  function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }
  //get cookie
  function getCookie(name) {
      var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
  }

  $('body').on('click', '[data-addcrosssell]', function(){
    setCookie('nocrosssell',false,1);
    var _this = this;
    var parentmodel = document.getElementById('crosssell-popup');
    parentmodel.open = false;    
    var varid = $(this).closest('#crosssell-popup').find('[name="vid"]').val();
    console.log(varid);
    console.log($('input[type="radio"][data-vid="'+varid+'"]').length);
    $('input[type="radio"][data-vid="'+varid+'"]').trigger('click');
    setTimeout(function(){      
      var formid = $(_this).closest('#crosssell-popup').attr('data-formid');
      $(`#${formid}`).find('[data-product-add-to-cart-button]').trigger('click');
    },100);
  });
  
  $('body').on('click', '[data-skipcontinue]', function(event){
    event.stopPropagation();
    setCookie('nocrosssell',false,1);
    var parentmodel = document.getElementById('crosssell-popup');
    parentmodel.open = false;    
    var formid = $(this).closest('#crosssell-popup').attr('data-formid');
    $(`#${formid}`).find('[data-product-add-to-cart-button]').trigger('click');
  });
  

  function applied_code(discountCodeValue, _this, sectionId){
    var existingDiscountsValue = existingDiscounts();
    if (existingDiscountsValue.includes(discountCodeValue)) return;
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          discount: [...existingDiscountsValue, discountCodeValue].join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      if (data.discount_codes.find((/** @type {{ code: string; applicable: boolean; }} */ discount) => {
          return discount.code === discountCodeValue && discount.applicable === false;
        })
      ) {
        $(_this).removeAttr('disabled');                                    
        $(_this).removeAttr('loading'); 
        $(_this).removeClass('loading');
        $('.cart-coupon_offer-input').append(`<div id="applied_code_error" class="applied_code_error text--xsmall">This discount code cannot be applied to your cart</div>`);
        setTimeout(function(){
          $('#applied_code_error').remove();
        },5000);
        return;
      }
      
      const newHtml = data.sections[sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
      $(_this).removeClass('loading');
    });
  }

  function existingDiscounts(){
    const discountCodes = [];
    const discountPills = $('#coupon-offers').find('.applied_coupon-item');
    for (const pill of discountPills) {
      if (typeof $(pill).attr('data-discount-code') === 'string') {
        discountCodes.push($(pill).attr('data-discount-code'));
      }
    }
    return discountCodes;
  }

  $('body').on('keyup','#coupon_code_input', function(){
    if($(this).val() != ''){
     $(this).closest('.cart-coupon_offer-input').find('.cart-coupon_offer-input_submit').addClass('active'); 
    }else{
     $(this).closest('.cart-coupon_offer-input').find('.cart-coupon_offer-input_submit').removeClass('active');
    }    
  });
  $('body').on('click','.cart-coupon_offer-input_submit.active', function(){
    var _this  = this;
    var discountCodeValue = $(this).closest('.cart-coupon_offer-input').find('#coupon_code_input').val();
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    if(discountCodeValue == ''){
      _this.closest('.cart-coupon_offer-input').after('<p class="offer_input_err">Please enter any code above.</p>');
      return;
    }
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','.cart-coupon_offer_item-coupon_button', function(){
    var _this  = this;
    var discountCodeValue = $(this).attr('coupon');
    var sectionId = $(_this).closest('cart-drawer').attr('section');
    $(_this).attr("disabled","disabled");
    $(_this).attr("loading","loading");

    $('#applied_code_error').remove();
    applied_code(discountCodeValue, _this, sectionId);
  });

  $('body').on('click','[data-removecode]', function(){
    console.log('hhiiihi')
    var sectionId = $(this).closest('cart-drawer').attr('section');
    var discountCodeValue = $(this).closest('.applied_coupon-item').attr('data-discount-code');
    var existingDiscountsValue = existingDiscounts();
    
    const index = existingDiscountsValue.indexOf(discountCodeValue);
    if (index === -1) return;

    existingDiscountsValue.splice(index, 1);
    
    async function getupdatedata(){     
      let response = await fetch(`${window.themeVariables.routes.cart_update_url}.js`, {
        method: "POST", // HTTP method (GET, POST, PUT, DELETE, etc.)
        headers : {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ 
          discount: existingDiscountsValue.join(','),
          sections: [sectionId]
        })
      });
      const data = await response.json();
      return data;
    }
    getupdatedata().then(data => {
      console.log(data);
      const newHtml = data.sections[sectionId];
      const parsedHtml = new DOMParser().parseFromString(newHtml, 'text/html');
      console.log(parsedHtml);
      $('.mini-cart__drawer-footer').html($(parsedHtml).find('.mini-cart__drawer-footer').html());
      $('#coupon-offers').html($(parsedHtml).find('#coupon-offers').html());
    });
  });


  function addFreeProduct(event, cart) {
    const settings = window.themeVariables?.settings;
    if (!settings) return;
    const freeProductId1 = settings?.free_item1?.variants?.[0]?.id;
    const milestone1 = parseInt(settings?.price_threshhold1 || "0") * 100;
    const existingGift = cart.items.find(i => i.variant_id === freeProductId1);
    if(existingGift){
      var total = parseInt(cart.total_price) - parseInt(existingGift.final_line_price);
    }else{
      var total = parseInt(cart.total_price);
    }
    var items = [];
    console.log($('[data-hasnoexceptitem]').attr('data-hasnoexceptitem'))
    if (total > milestone1 && $('[data-hasnoexceptitem]').attr('data-hasnoexceptitem') == 'true') {
      console.log('innnnn')
      if (!existingGift) {
        items.push({
          quantity: 1,
          id: freeProductId1
        });
        var data = {items};
        console.log('data',data)
        $('#free-gift-added-popover-1').show();
        fetch('/cart/add.js', {
          method: 'POST',
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {   
          console.log("Free gift added");   
          
          setTimeout(function() {
            $('#free-gift-added-popover-1').hide();
          }, 3000);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));
          
        }.bind(this));  
      }
    }
    else{
      console.log('elsss')
      if (existingGift) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            id: existingGift.key,
            quantity: 0
          },
          dataType: 'json',
          success: function() {
            console.log('Free gift removed');
            refreshCart();
          },
          error: function(err) {
            console.log('Error removing free gift', err);
          }
        });
      }
    }
    function refreshCart() { 
      $.getJSON("/cart.js", function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: { cart }
        })); 
      });
    }
  }

  document.addEventListener('minicart:update', function(event) {
    console.log('event',event);
    if(event.detail.cart != null){
      console.log('iffff');
      var cart = event.detail.cart; // Get the updated content of the cart
      addFreeProduct(event,cart);
    }
  });


  $('.free-gift-added-popover-footer').click(function(){
    $('#free-gift-added-popover-1').hide();
  });
  
  $('.product-item__cta[type="button"]').click(function(){
    var _this = this;
    $(this).attr("aria-busy",true);
    setTimeout(function() { 
        $(_this).removeAttr('aria-busy', false);
    }, 1000);
  });

  $('body').on('click','.scrollto_fix', function(e){
    e.preventDefault();
     var totalremove = $('.header').height() + 88;
     console.log(totalremove);
    var crossheight =  $($(this).attr('href')).offset().top - totalremove;
    $('html, body').animate({
        scrollTop: crossheight
    }, 300)
  });
});

if($('body').hasClass('template-collection')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if( $('product-list.product-facet__product-list').height() - 800 < $(document).scrollTop()) {
      var loadingImage;
      pInfScrNode = $('.product-list__inner.grid_view_custom').find('.more');	        
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        pInfScrURL = $('.product-list__inner.grid_view_custom').find('.more a').attr("href");
        $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0577/3973/9224/files/Spinner_1x-1.0s-343px-343px.gif?v=1748871803" class="loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingImage = pInfScrNode.clone().empty().append('');
            loadingImage.insertAfter(pInfScrNode);
            pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {
            // remove loading feedback
            pInfScrNode.next().remove();
            var filteredData = $(data).find(".product-list__inner");
            // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
            $('.product-list__inner.grid_view_custom').find('.more').before(filteredData.html());
            $('.product-list__inner.grid_view_custom').find('.more:not(:last-child)').remove();
            if(filteredData.find('.more').length > 0){
              $('.product-list__inner.grid_view_custom').find('.more').html(filteredData.find('.more').html());
            }else{
              $('.product-list__inner.grid_view_custom').find('.more').remove();
            }
            
            
            loadingImage.remove();	              
            $('.product-list').find('.loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },
          dataType: "html"
        });
      }
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('product-list.product-facet__product-list').height() - 800 < $(document).scrollTop()) {
        pInfScrDelay = 0;
      }
    });
  });
}
